import { GS_COMPONENTS } from '@gs/ui';

/** Echelle D12 : deux tailles max (court numerique, moyen). */
export const INPUT_SHORT = `${GS_COMPONENTS.input} w-28`;
export const INPUT_MEDIUM = `${GS_COMPONENTS.input} w-40`;

/** Fraction -> points, arrondi a 1 decimale (parite PoC toPoints). */
export const toPoints = (fraction: number): number => Math.round(fraction * 1000) / 10;
/** Points -> fraction, arrondi a 6 decimales (DECIMAL(8,6)). */
export const toFraction = (points: number): number => Math.round(points * 10_000) / 1_000_000;
